/**
 * Active entry: functional manager login page.
 * Legacy class: ./LogInAdmin.js
 */
import LogInAdminPage from "./LogInAdminPage";

export default LogInAdminPage;
